import { LegalClientFinancialMonitoringEntity } from 'api/types/entity';
import { yesOrNot } from 'helpers';
import { TFunc } from 'libs/i18n';

import {
  CompanyFinancialMonitoringFormType,
  getAmlPolicyReviewFrequencySelectedOption,
  getMonetaryServiceTransactionCountForLastSixMonthsSelectedOption,
} from '../../forms/companyFinancialMonitoringForm';

export const getInitialData = (
  t: TFunc,
  data?: LegalClientFinancialMonitoringEntity
): CompanyFinancialMonitoringFormType | undefined => {
  if (!data) {
    return undefined;
  }

  return {
    isSubjectToRegulation: yesOrNot(t, data.isSubjectToRegulation),
    authorityName: data.financeInfo?.authorityName,
    authorityWebsite: data.financeInfo?.authorityWebsite ?? undefined,
    hasAmlCftComplianceControl: yesOrNot(
      t,
      data.financeInfo?.hasAmlCftComplianceControl
    ),
    hasTransactionMonitoringAndSuspiciousActivityDetection: yesOrNot(
      t,
      data.financeInfo?.hasTransactionMonitoringAndSuspiciousActivityDetection
    ),
    amlPolicyReviewFrequency: getAmlPolicyReviewFrequencySelectedOption(
      t,
      data.financeInfo?.amlPolicyReviewFrequency
    ),
    otherAmlPolicyReviewFrequency:
      data.financeInfo?.otherAmlPolicyReviewFrequency ?? undefined,
    amlCftPoliciesApplyToForeignEntities: yesOrNot(
      t,
      data.financeInfo?.amlCftPoliciesApplyToForeignEntities ?? undefined
    ),
    hasAmlCftDocumentEffectivenessAssessmentProcedures: yesOrNot(
      t,
      data.financeInfo?.hasAmlCftDocumentEffectivenessAssessmentProcedures
    ),
    dateOfLastCheck: data.financeInfo?.dateOfLastCheck ?? undefined,
    hasAmlCftInternalControlOfficer: yesOrNot(
      t,
      data.financeInfo?.hasAmlCftInternalControlOfficer
    ),
    officerFirstName: data.financeInfo?.officer?.firstName,
    officerLastName: data.financeInfo?.officer?.lastName,
    officerMiddleName: data.financeInfo?.officer?.middleName ?? undefined,
    officerPosition: data.financeInfo?.officer?.position,
    officerPhoneNumber: data.financeInfo?.officer?.phoneNumber,
    officerEmail: data.financeInfo?.officer?.email,
    canProvideAmlPolicyDocuments: yesOrNot(
      t,
      data.financeInfo?.canProvideAmlPolicyDocuments
    ),
    documentProvisionRefusalReason:
      data.financeInfo?.documentProvisionRefusalReason ?? undefined,
    isInternalControlInfoConfidential: yesOrNot(
      t,
      data.financeInfo?.isInternalControlInfoConfidential
    ),
    hadAmlCftInvestigationsOrPenalties: yesOrNot(
      t,
      data.financeInfo?.hadAmlCftInvestigationsOrPenalties
    ),
    investigationOrPenaltyReasons:
      data.financeInfo?.investigationOrPenaltyReasons ?? undefined,
    hasMandatoryControlTransactions: yesOrNot(
      t,
      data.financeInfo?.hasMandatoryControlTransactions
    ),
    mandatoryControlTransactionIdentificationProcedure:
      data.financeInfo?.mandatoryControlTransactionIdentificationProcedure ??
      undefined,
    monetaryServiceTransactionCountForLastSixMonths:
      getMonetaryServiceTransactionCountForLastSixMonthsSelectedOption(
        t,
        data.financeInfo?.monetaryServiceTransactionCountForLastSixMonths
      ),
    isAffiliatedWithNonProfitOrganizations: yesOrNot(
      t,
      data.financeInfo?.isAffiliatedWithNonProfitOrganizations
    ),
    receivesFundingFromStateBudget: yesOrNot(
      t,
      data.financeInfo?.receivesFundingFromStateBudget
    ),
    receivesFundingFromForeignNonProfitNGOs: yesOrNot(
      t,
      data.financeInfo?.receivesFundingFromForeignNonProfitNGOs
    ),
    isCompliantWithFATFRecommendations: yesOrNot(
      t,
      data.financeInfo?.isCompliantWithFATFRecommendations
    ),
    hasBeenRefusedToOpenAccountByBanks: yesOrNot(
      t,
      data.financeInfo?.hasBeenRefusedToOpenAccountByBanks
    ),
  };
};
